import {Component, EventEmitter, Input, Output, OnInit} from '@angular/core';

/**
 * Component for showing a forecast chart
 */
@Component({
    selector: 'app-forecast-chart',
    templateUrl: './forecast-chart.component.html',
    standalone: false
})
export class ForecastChartComponent implements OnInit {

  /**
   * holds the anfrage object
   */
  @Input() anfrage: any;

  /**
   * data for different cases to show different info texts
   */
  @Input() dataCases: {stages?: any, isApartement?: boolean, hasWarmwater?: boolean, isMfhOwnerCentralHeating?: boolean, isFossilEnergySource: {fossil: boolean, gas: boolean, oil: boolean}, isDistrictHeating: boolean};

  /**
   * placeholder for the texts
   */
  @Input() placeholder: {};

  /**
   * forecast data for the chart
   */
  @Input()  forecastData: {
    market: { year: string, energy: number, co2: number, costs: number, extraCosts: number, percentage?: number }[],
    real: { year: string, energy: number, co2: number, costs: number, extraCosts: number, percentage?: number }[],
    activeType: 'market' | 'real'
  } = {market: [], real: [], activeType: 'market'};

  /**
   * compare data for the chart
   */
  @Input() compareData: {average?: {value: number, percent: number}, costs: {value: number, percent: number, heating?: number, water?: number, waterPercent?: number}, estimate?: {value: number, percent: number}};

  /**
   * Toogle for showhing/hiding hints
   */
  @Input()  hints: {[key: string]: boolean} = {avg: false, costs: false, estimate: false, forecast: false};

  /**
   * Textkeyprefix for the used texts
   */
  @Input() textkeyPrefix: string;

  /**
   *
   */
  @Input() mode: string = 'hec';

  /**
   * define the case to show different info texts
   */
  textCases: {avg: string, costs: string, forecast: any} = {avg: 'building', costs: '', forecast: []};

  /**
   * Represents the unit of measurement for costs displayed over the bars.
   * Default value is 'euro'.
   */
  costsUnit: string = 'euro';

  /**
   * Emits an event to the parent to notify which info box should be toggled
   */
  @Output() hintToggled = new EventEmitter<string>();

  /**
   * Emits an event to the parent to notify which chart data should be shown, market or real prices
   */
  @Output() typeChanged = new EventEmitter<'market' | 'real'>();

  /**
   * @inheritDoc
   */
  ngOnInit() {
   this.initInfoTextkeys();

   // init forecast type and save it in the anfrage object, as default type is 'market'
   this.anfrage.verbrauchsanalyseInput.forecastType = this.forecastData.activeType;

   // define the cost unit
   this.costsUnit = this.mode === 'hka' ? 'percent' : 'euro';
  }
  /**
   * Called when a info button is clicked.
   * @param key
   */
  onButtonClick(key: string): void {
    this.hintToggled.emit(key);
  }

  /**
   * Called when the user toggles the chart between market and real data.
   * @param type
   */
  changeForecastType(type: 'market' | 'real') {
    this.typeChanged.emit(type);

    // get the active forecast type and save changes in the anfrage object
    this.anfrage.verbrauchsanalyseInput.forecastType = type;
  }

  /**
   * Sets the textkeys for the info boxes.
   */
  initInfoTextkeys(): void {
    // textkeys for hec path
    if (this.mode === 'hec') {
      // average section
      this.textCases.avg = this.dataCases.isApartement ? 'apartement' : (this.dataCases.isMfhOwnerCentralHeating ? 'mfhOwner' : 'building');

      // costs section
      this.textCases.costs = this.dataCases.isMfhOwnerCentralHeating? '.mfhOwner' : '';

      // forecast section
      this.textCases.forecast[0] = this.dataCases.isMfhOwnerCentralHeating? '.mfhOwner' : '.building';
      if (this.dataCases.isFossilEnergySource['gas']) {
        this.textCases.forecast[1] = '.fossil.gas'
      }
      else if (this.dataCases.isFossilEnergySource['oil']) {
        this.textCases.forecast[1] = '.fossil.oil'
      }
      else if (this.dataCases.isDistrictHeating) {
        this.textCases.forecast[1] = '.district'
      }
      else {
        this.textCases.forecast[1] = '';
      }

      this.textCases.forecast[2] = '.basis';
    }

    // textkeys for hka path
    if (this.mode === 'hka') {
      if (this.dataCases.isFossilEnergySource['gas']) {
        this.textCases.forecast[0] = '.fossil.gas';
      }
      else if (this.dataCases.isFossilEnergySource['oil']) {
        this.textCases.forecast[0] = '.fossil.oil';
      }
      else if (this.dataCases.isDistrictHeating) {
        this.textCases.forecast[0] = '.district';
      }
      else {
        this.textCases.forecast[0] = '';
      }
    }
  }
}
